/* THEME SPECIFIC IMPORTS */
const $ = require("jquery");
window.$ = $;
window.jQuery = $;

// TODO: Check why this cannot be imported
// require('./theme/porto/vendor/modernizr/modernizr.min.js')
require("./theme/porto/vendor/jquery.appear/jquery.appear.min.js");
require("./theme/porto/vendor/jquery.easing/jquery.easing.min.js");
require("./theme/porto/vendor/jquery-cookie/jquery-cookie.min.js");
require("./theme/porto/vendor/popper/umd/popper.min.js");
require("./theme/porto/vendor/bootstrap/js/bootstrap.min.js");
require("./theme/porto/vendor/common/common.min.js");
require("./theme/porto/vendor/jquery.validation/jquery.validation.min.js");
require("./theme/porto/vendor/jquery.easy-pie-chart/jquery.easy-pie-chart.min.js");
require("./theme/porto/vendor/jquery.gmap/jquery.gmap.min.js");
require("./theme/porto/vendor/jquery.lazyload/jquery.lazyload.min.js");
require("./theme/porto/vendor/isotope/jquery.isotope.min.js");
require("./theme/porto/vendor/owl.carousel/owl.carousel.min.js");
require("./theme/porto/vendor/magnific-popup/jquery.magnific-popup.min.js");
require("./theme/porto/vendor/vide/vide.min.js");
require("./theme/porto/js/theme.js");
// TODO: Check why this cannot be imported
// require('./theme/porto/vendor/rs-plugin/js/jquery.themepunch.revolution.min.js');
// require('./theme/porto/vendor/rs-plugin/js/jquery.themepunch.tools.min.js');
require("./theme/porto/js/views/view.contact.js");
require("./theme/porto/js/demos/demo-real-estate.js");

const Galleria = require("./theme/galleria/galleria.min.js");
window.Galleria = Galleria; // webpack

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./axios";
import sentry from "./sentry";
import "./validation/veevalidate";
// import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtag from "vue-gtag";
import * as GmapVue from "gmap-vue";
import VCalendar from "v-calendar";
import Popover from "vue-js-popover";
import Moment from "vue-moment";
import QueryParser from "@/utils/QueryParser";
import { i18n } from "./i18n";
import VueMeta from "vue-meta";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueLazyload from "vue-lazyload";
import VueMobileDetection from "vue-mobile-detection";
import Vue2TouchEvents from "vue2-touch-events";
import VBodyScrollLock from "v-body-scroll-lock";

Vue.use(QueryParser);
Vue.use(VueMobileDetection);
Vue.use(Vue2TouchEvents);
Vue.use(VBodyScrollLock);

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    isUndefined: (obj) => {
      // Special case
      if (obj === null || obj === undefined) {
        return true;
      }
      let res = Object.entries(obj).length === 0 && obj.constructor === Object;

      return res;
    },
    allFieldsAreUndefined: (obj) => {
      let keys = Object.keys(obj);

      for (let i = 0; i < keys.length; i++) {
        if (obj[keys[i]] !== undefined) {
          console.log("Found field that is undefined: " + keys[i]);
          return false;
        }
      }

      return true;
    },
    resolvePosterImage: function (listing) {
      let DEFAULT_URL = `/images/default/download/full`;

      if (
        listing === undefined ||
        listing.images === undefined ||
        listing.images.length === 0
      ) {
        return DEFAULT_URL;
      }

      let URL = `${this.STATIC_ASSETS_URL}/${listing.images[0].small.filename}`;

      return URL;
    },
    resolveImage: function (image, size) {
      let DEFAULT_URL = `${this.STATIC_ASSETS_URL}/default`;
      if (image === undefined || image === null) {
        return DEFAULT_URL;
      }

      let sizedImage = image[size];
      if (sizedImage === undefined) {
        return DEFAULT_URL;
      }

      return `${this.STATIC_ASSETS_URL}/${sizedImage.filename}`;
    },
    normalizeDate: function (inputDate) {
      /*
      This function is used to remove the timezone (and offset) 
      from the date, and return a format that the server can understand
      */
      if (inputDate === undefined) {
        return undefined;
      }
      let d = new Date(inputDate);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      let year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let res = [year, month, day].filter((el) => !isNaN(el));

      return res < 3 ? undefined : res.join("-");
    },
    getEditable: (obj) => {
      // Returns an editable version of the passed obj
      return Object.assign({}, obj);
    },
    castDate: (d) => {
      if (!(d instanceof Date) && d !== undefined && d !== null) {
        d = new Date(d);
      }

      // Check if the result is valid
      if (d === null || d === undefined || isNaN(d.getTime())) {
        return undefined;
      }

      return d;
    },
    getErrorMessage: function (err) {
      return err.response ? err.response.data.message : "Unknown error";
    },
  },
});

Vue.filter("pretty", function (value) {
  let parsed = undefined;
  try {
    parsed = JSON.stringify(JSON.parse(value), null, 4);
  } catch {
    parsed = JSON.stringify(value, null, 4);
  }

  if (parsed === undefined) {
    return "Could not parse JSON";
  }

  return parsed;
});

Vue.filter("baseUrl", function (value) {
  return axios.apiUrl + value;
});

Vue.filter("truncate", function (text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
});

const API_KEY = "AIzaSyDf9QkYIbPs8Gq7-aA7kCjtw3u1R_I1cnw";

Vue.use(GmapVue, {
  load: {
    key: API_KEY,
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

Vue.component("google-marker", GmapVue.Marker);

if (process.env.VUE_APP_ENV === "production") {
  Vue.use(
    VueGtag,
    {
      config: {
        id: "G-FV5HWVVLT1",
      },
    },
    router
  );
  console.log("Google analytics has been activated");
} else {
  console.log("Google analytics is DEACTIVATED");
}

// Vue.use(VueReCaptcha, {
//   siteKey: '<site key>',
//   loaderOptions: {
//     useRecaptchaNet: true
//   }
// })

Vue.use(VCalendar, {
  componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(VueLazyload, {
  loading: `${process.env.VUE_APP_BASE_URL}/spinner.gif`,
});

Vue.use(Popover);
Vue.use(Moment);
Vue.use(VueMeta);

Vue.filter("dateFormat", function (value) {
  if (value === undefined) {
    return "";
  }

  // Let's see if if is a weird format
  if (typeof value === "string" && value.split("-").length === 2) {
    // We know the format is MM-DD
    return `${value.split("-").reverse().join(".")}.`;
  }

  let standardDate = Vue.prototype.$moment(value).format("DD.MM.YYYY");
  if (standardDate) {
    return standardDate;
  }

  return "";
});

Vue.filter("localized", function (value) {
  let loc = Vue.prototype.$i18n || i18n;
  if (loc === undefined || loc === null) {
    return undefined;
  }

  const localizedValue = value[loc.locale];
  if (localizedValue === undefined || localizedValue === null) {
    return value["de"];
  }
  return localizedValue;
});

Vue.filter("removeHTML", function (value) {
  return value.replace(/<br>/g, ".").replace(/<\/?[^>]+(>|$)/g, "");
});

router.beforeEach((to, from, next) => {
  console.log("From " + from.path + " to " + to.path);
  next();
});

new Vue({
  router,
  store,
  i18n,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
